import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { StorageService } from "../../../../routes/services/storage.service";
import { Uris } from "../../../../routes/services/Uris";
import { MaintenanceConfigRegion } from "../interfaces/maintenance_alert.interfaces";

@Injectable({
  providedIn: "root"
})
export class MaintenanceAlertService {
  constructor(
    public storageService: StorageService,
    private http: HttpClient,
    public router: Router
  ) {}

  /**
   * Obtiene el listado de configuraciones de alerta de mantenimiento.
   * @param query Query string de filtros/paginación (ej. `?region=1`).
   * @returns Observable con el listado paginado.
   */
  list(query = ""): Observable<any> {
    return this.http
      .get(Uris.CONFIG + "region-maintenance/" + query, this.storageService.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        })
      );
  }

  /**
   * Crea una configuración de alerta de mantenimiento para una región.
   * @param body Días de la alerta y región a la que pertenece.
   * @returns Observable con la configuración creada.
   */
  create(body: Partial<MaintenanceConfigRegion>): Observable<MaintenanceConfigRegion> {
    return this.http
      .post<MaintenanceConfigRegion>(
        Uris.CONFIG + "region-maintenance/",
        body,
        this.storageService.headers()
      )
      .pipe(
        map((resp: MaintenanceConfigRegion) => {
          return resp;
        })
      );
  }

  /**
   * Actualiza parcialmente una configuración de alerta de mantenimiento existente.
   * @param id Identificador de la configuración a actualizar.
   * @param body Campos a modificar.
   * @returns Observable con la configuración actualizada.
   */
  update(id: number, body: Partial<MaintenanceConfigRegion>): Observable<MaintenanceConfigRegion> {
    return this.http
      .patch<MaintenanceConfigRegion>(
        Uris.CONFIG + "region-maintenance/" + id + "/",
        body,
        this.storageService.headers()
      )
      .pipe(
        map((resp: MaintenanceConfigRegion) => {
          return resp;
        })
      );
  }
}
